/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */

import React, {useContext, useEffect, useRef} from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import InwardList from './InwardList';
import OutwardList from './OutwardList';
import GlobalContext from '../../../components/Context/GloablContext';

export default function TransferStudent() {
    const { isSideNavBar } = useContext(GlobalContext);
    const [searchParams, setSearchParams] = useSearchParams({type : 'inward_list'});
    const location = useNavigate();
    const tableContainerRef = useRef()
    const handleTabSwitch = (type) => {
        let params = Object.fromEntries(searchParams);
        params.type = type
        setSearchParams({type: type})
    }
    useEffect(() => {
        if(searchParams.get("type") === null) {
            handleTabSwitch("inward_list")
        }
    }, [searchParams])

    return (
        <div className={` w-full main-screenInst overflow-x-hidden max-h-screen min-h-screen relative ${!isSideNavBar ? 'w-[270px] ' : ''}`} ref={tableContainerRef} >
            <div className={`mainDataCntnr ${!isSideNavBar ? 'normal' : 'wide'}`}>
                <div className="mainDataCntnrTop shadow-s13">
                    <div className="flex items-center">
                        <h5 className="pageHeader adderror">Transfers</h5>
                    </div>
                </div>
                <div className="pb-10 relative">
                    <ul className="mr-4 ml-4 flex list-none flex-row flex-wrap border-b border-[#B3BBC1] pl-9 pt-6 bg-[#fff] sticky top-[64px] left-0 z-[10] -mx-1" role="tablist" data-te-nav-ref="">
                        <li >
                            <p
                                id="inward_list"
                                onClick={() => handleTabSwitch("inward_list")}
                                className={`${searchParams.get("type") === "inward_list" ? "selected" : ""}  mr-[126px] tab-element`}
                            >Inward List</p>
                        </li>
                        <li>
                            <p
                                id="outward_list"
                                className={`${searchParams.get("type") === "outward_list" ? "selected" : ""} tab-element`}
                                onClick={() => handleTabSwitch("outward_list")}
                            >Outward List</p>
                        </li>
                    </ul>
                    {searchParams.get("type") === "inward_list"
                        ? <InwardList searchParams={searchParams} setSearchParams={setSearchParams} />
                        : <OutwardList searchParams={searchParams} setSearchParams={setSearchParams} />}
                </div>
            </div>
        </div>
    )
}
